export default (state = {}, action = {}) => {
  const {type, payload = {}} = action;
  switch (type) {
    default: {
      if (payload.cluster) {
        return {...state, ...payload.cluster};
      }
      return state;
    }
  }
};
